import { Injectable, signal, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AuthService } from 'src/app/authentication/auth.service';
import { ConstantService } from 'src/app/services/common/constant.service';
import { OrganizationModel, OrganizationService } from 'src/app/services/organization';

@Injectable({ providedIn: 'root' })
export class TenantSwitcherStore {
  
  private readonly constantService = inject(ConstantService);
  private readonly authService = inject(AuthService);
  private readonly organizationService = inject(OrganizationService);

  defaultTenant = signal<OrganizationModel>(this.constantService.mspTenant);
  currentTenant = signal<OrganizationModel>(this.constantService.mspTenant);
  organizations = signal<OrganizationModel[]>([]);

  setTenant(tenant:OrganizationModel) {
    this.currentTenant.set(tenant);
    this.constantService.setMspTenant(tenant);
    this.authService.reloadPage();
  }

  resetDefaultTenant(){
    this.setTenant(this.defaultTenant());
  }

  getCurrentTenant(){
    return this.currentTenant() ? this.currentTenant()?.organizationName : this.constantService.getSubdomain();
  }

  public async fetchOrgs(): Promise<void> {
    try{
      const data = await firstValueFrom(this.organizationService.apiOrganizationGetOrganizationAllGet());
      this.organizations.set(data.sort((a:OrganizationModel, b:OrganizationModel) => a.organizationName?.localeCompare(b.organizationName)));
      this.defaultTenant.set(data.find((o:OrganizationModel) => o.mnemonic == this.constantService.getDefaultTenant()));
    }catch(error){
      console.log(error);
    }
  }
  
}
